import { RouteSkeleton } from '@/shared/components/RouteSkeleton'
import { activationStore } from '@/stores/activation.store'
import { authStore } from '@/stores/auth.store'
import { Navigate } from '@solidjs/router'
import { type JSX, Show } from 'solid-js'
import { nextOnboardingStop, routeForStop } from './onboardingChain'

interface ActivationGateProps {
  children: JSX.Element
}

export function ActivationGate(props: ActivationGateProps) {
  const waiting = () => authStore.state.userType === 'candidate' && !activationStore.isLoaded()

  return (
    <Show when={!waiting()} fallback={<RouteSkeleton />}>
      <Show when={nextOnboardingStop()} fallback={props.children}>
        {(stop) => <Navigate href={routeForStop(stop())} />}
      </Show>
    </Show>
  )
}
